import { useMapStore } from "stores/map";

export function useUpdateLayerLineThickness() {
  const setDisplaySettings = useMapStore((s) => s.setDisplaySettings);

  const updateLayerLineThickness = (newThickness: number) => {
    // Functional updater (EVA-63) — avoids spreading a stale render-time
    // `displaySettings` snapshot over a concurrently-applied View restore.
    setDisplaySettings((current) => ({ ...current, wellLineThickness: newThickness }));
  };
  return { updateLayerLineThickness };
}
